import { ResponsiveContainer } from "recharts";

const BaseResponsiveContainer = (props)=>{
    return <ResponsiveContainer {...props}>
        {props.children}
    </ResponsiveContainer>
}

export default BaseResponsiveContainer;